import React, { lazy } from "react";
import { Route, Redirect } from "react-router-dom";

// keuangan
import {
  DaftarAnggaran,
  DaftarKategoriAnggaran,
  DaftarBelanja,
  DaftarKategoriBelanja,
  TambahBelanja,
  TambahAnggaranPendapatan,
  TambahKategoriPendapatan,
  TambahKategoriBelanja,
  EditKategoriAnggaran,
  EditAnggaran,
  EditKategoriBelanja,
  EditBelanja,
} from "~/pages/keuangan";

// pengguna
import {
  DaftarPengguna,
  EditPengguna,
  EditPassword as EditPasswordPengguna,
} from "~/pages/pengguna";

//layanan
import { FormCetak } from "~/pages/layanan/index";

// website
import {
  DaftarBerita,
  DaftarKategoriBerita,
  TambahKategoriBerita,
  EditBerita,
  EditKategoriBerita,
  TambahBerita,
  DaftarPotensi,
  TambahPotensi,
  EditPotensi,
  DaftarInformasi,
  DaftarKategoriInformasi,
  TambahKategoriInformasi,
  EditInformasi,
  EditKategoriInformasi,
  TambahInformasi,
  DaftarHero,
  TambahHero,
  EditHero,
  HeroSetting,
} from "~/pages/website";
import { ROLES } from "~/utils";
import ErrorPageNotFound from "~/pages/error/PageNotFound";
import PrivateRoute from "~/routes/PrivateRoute";

// hard reset

//cctv
const DaftarCCTV = React.lazy(() => import("~/pages/cctv/DaftarCCTV"));
const DaftarCCTVTable = React.lazy(() =>
  import("~/pages/cctv/DatfarCCTVTable")
);
const PersebaranPetaCCTV = React.lazy(() =>
  import("~/pages/cctv/PersebaranPetaCCTV")
);
const TambahCCTV = React.lazy(() => import("~/pages/cctv/TambahCCTV"));
const UbahCCTV = React.lazy(() => import("~/pages/cctv/UbahCCTV"));

//laporWarga
const LaporWarga = lazy(() => import("~/pages/lapor-warga/Daftar"));

//login
const LoginHyperHtml = lazy(() => import("~/pages/auth/Login"));
const EditPassword = lazy(() => import("~/pages/auth/EditPassword"));

//dashboard
const Dashboard = lazy(() => import("~/pages/dashboard"));
//keluarga
const DaftarKeluarga = lazy(() => import("~/pages/keluarga/DaftarKeluarga"));
const DetailFormKeluarga = lazy(() =>
  import("~/pages/keluarga/DetailFormKeluarga")
);
const UbahFormKeluarga = lazy(() =>
  import("~/pages/keluarga/UbahFormKeluarga")
);
const TambahFormKeluarga = lazy(() =>
  import("~/pages/keluarga/TambahFormKeluarga")
);
//penduduk
const DaftarPenduduk = lazy(() => import("~/pages/penduduk/DaftarPenduduk"));
const FormPenduduk = lazy(() => import("~/pages/penduduk/TambahPenduduk"));
const EditPenduduk = lazy(() => import("~/pages/penduduk/EditPenduduk"));
const DetailPenduduk = lazy(() => import("~/pages/penduduk/DetailPenduduk"));

//layanan v2

const ListsConfigLayanan = lazy(() =>
  import("~/pages/dynamic-layanan/ListsConfig")
);
const ListsSuratLayanan = lazy(() =>
  import("~/pages/dynamic-layanan/surat/ListsSurat")
);
const CreateSuratLayanan = lazy(() =>
  import("~/pages/dynamic-layanan/surat/CreateSurat")
);
const PrintSuratLayanan = lazy(() =>
  import("~/pages/dynamic-layanan/surat/PrintSurat")
);

//layanan
const DynamicListAdministrasi = lazy(() =>
  import("~/pages/layanan/administrasi/DynamicList")
);
const DaftarLayananAdministrasi = lazy(() =>
  import("~/pages/layanan/administrasi/DaftarLayananAdministrasi")
);
const KategoriLayanan = lazy(() => import("~/pages/layanan/KategoriLayanan"));

const PersyaratanAdministrasi = lazy(() =>
  import("~/pages/layanan/administrasi/PersyaratanSurat")
);
const GenerateSurat = lazy(() => import("~/pages/layanan/GenerateSurat"));

//perangkat
const DaftarPerangkat = lazy(() => import("~/pages/perangkat/DaftarPerangkat"));
const EditPerangkat = lazy(() => import("~/pages/perangkat/EditPerangkat"));
const TambahFormPerangkat = lazy(() =>
  import("~/pages/perangkat/TambahFormPerangkat")
);
const TambahKePengguna = lazy(() =>
  import("~/pages/perangkat/TambahKePengguna")
);
const DetailPerangkat = lazy(() => import("~/pages/perangkat/DetailPerangkat"));

//jabatan

const DaftarJabatan = lazy(() =>
  import("~/pages/perangkat/jabatan/DaftarJabatan")
);
const EditJabatan = lazy(() => import("~/pages/perangkat/jabatan/EditJabatan"));
const TambahJabatan = lazy(() =>
  import("~/pages/perangkat/jabatan/TambahJabatan")
);

//presensi
const DaftarPresensi = lazy(() => import("~/pages/perangkat/DaftarPresensi"));
const TambahPresensi = lazy(() => import("~/pages/perangkat/TambahPresensi"));

//peristiwa
const DaftarKelahiran = lazy(() =>
  import("~/pages/peristiwa/kelahiran/DaftarKelahiran")
);
const DaftarKematian = lazy(() =>
  import("~/pages/peristiwa/kematian/DaftarKematian")
);
const DaftarLahirMati = lazy(() =>
  import("~/pages/peristiwa/lahirMati/DaftarLahirMati")
);
const DaftarPecahKK = lazy(() =>
  import("~/pages/peristiwa/pecahkk/DaftarPecahKK")
);
const DaftarPindahKeluar = lazy(() =>
  import("~/pages/peristiwa/pindahkeluar/DaftarPindahKeluar")
);
const DaftarPindahMasuk = lazy(() =>
  import("~/pages/peristiwa/datangmasuk/DaftarPindahMasuk")
);

//tambahperistiwa
const TambahKelahiran = lazy(() =>
  import("~/pages/peristiwa/kelahiran/TambahKelahiran")
);
const TambahPecahKK = lazy(() =>
  import("~/pages/peristiwa/pecahkk/TambahPecahKK")
);
const PindahKelahiranPenduduk = lazy(() =>
  import("~/pages/peristiwa/kelahiran/PindahKelahiranKePenduduk")
);
const TambahPindahKeluar = lazy(() =>
  import("~/pages/peristiwa/pindahkeluar/TambahPindahKeluar")
);
const TambahKematian = lazy(() =>
  import("~/pages/peristiwa/kematian/TambahKematian")
);
const TambahPindahMasuk = lazy(() =>
  import("~/pages/peristiwa/datangmasuk/TambahPindahMasuk")
);
const TambahLahirMati = lazy(() =>
  import("~/pages/peristiwa/lahirMati/TambahLahirMati")
);

//detailPeristiwa
const DetailKelahiran = lazy(() =>
  import("~/pages/peristiwa/kelahiran/DetailKelahiran")
);
const DetailPecahKK = lazy(() =>
  import("~/pages/peristiwa/pecahkk/DetailPecahKK")
);
const DetailLahirMati = lazy(() =>
  import("~/pages/peristiwa/lahirMati/DetailLahirMati")
);
const DetailKematian = lazy(() =>
  import("~/pages/peristiwa/kematian/DetailKematian")
);
const DetailPindahKeluar = lazy(() =>
  import("~/pages/peristiwa/pindahkeluar/DetailPindahKeluar")
);
const DetailDatangMasuk = lazy(() =>
  import("~/pages/peristiwa/datangmasuk/DetailDatangMasuk")
);

//ubah peristiwa
const UbahKelahiran = lazy(() =>
  import("~/pages/peristiwa/kelahiran/UbahKelahiran")
);
const UbahLahirMati = lazy(() =>
  import("~/pages/peristiwa/lahirMati/UbahLahirMati")
);

//persuratan
const DaftarSuratMasuk = lazy(() =>
  import("~/pages/persuratan/DaftarSuratMasuk")
);
const DaftarSuratKeluar = lazy(() =>
  import("~/pages/persuratan/DaftarSuratKeluar")
);
const TambahSuratMasuk = lazy(() =>
  import("~/pages/persuratan/TambahSuratMasuk")
);
const TambahSuratKeluar = lazy(() =>
  import("~/pages/persuratan/TambahSuratKeluar")
);
const DetailSuratMasuk = lazy(() =>
  import("~/pages/persuratan/DetailSuratMasuk")
);
const DetailSuratKeluar = lazy(() =>
  import("~/pages/persuratan/DetailSuratKeluar")
);
const UbahSuratMasuk = lazy(() => import("~/pages/persuratan/UbahSuratMasuk"));
const UbahSuratKeluar = lazy(() =>
  import("~/pages/persuratan/UbahSuratKeluar")
);

//profil
const ProfilDesa = React.lazy(() => import("~/pages/profil/ProfilDesa"));
const VisiDanMisi = React.lazy(() => import("~/pages/profil/VisiDanMisi"));
const Sejarah = React.lazy(() => import("~/pages/profil/Sejarah"));
const UpdateBatasDesa = React.lazy(() =>
  import("~/pages/profil/UpdateBatasDesa")
);
const DaftarSubDesa = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/subdesa/daftar-subdesa")
);
const DaftarSubSubDesa = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/subsubdesa/daftar-subsubdesa")
);
const DaftarRW = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/rw/daftar-rw")
);
const DaftarRT = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/rt/daftar-rt")
);
const TambahSubDesa = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/subdesa/tambah")
);
const TambahSubSubDesa = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/subsubdesa/tambah")
);
const TambahRW = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/rw/tambah")
);
const TambahRT = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/rt/tambah")
);
const UbahSubDesa = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/subdesa/ubah")
);
const UbahSubSubDesa = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/subsubdesa/ubah")
);
const UbahRW = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/rw/ubah")
);
const UbahRT = React.lazy(() =>
  import("~/pages/profil/hirarki-wilayah/rt/ubah")
);

//sarpras
const DaftarSaranaPrasarana = lazy(() =>
  import("~/pages/sarana-prasarana/DaftarSaranaPrasarana")
);
const TambahSaranaPrasarana = lazy(() =>
  import("~/pages/sarana-prasarana/TambahSaranaPrasarana")
);
const DetailSaranaPrasarana = lazy(() =>
  import("~/pages/sarana-prasarana/DetailSaranaPrasarana")
);
const UbahSaranaPrasarana = lazy(() =>
  import("~/pages/sarana-prasarana/UbahSaranaPrasarana")
);
//inventaris
const DaftarInventaris = lazy(() =>
  import("~/pages/inventaris/DaftarInventaris")
);
const TambahInventaris = lazy(() =>
  import("~/pages/inventaris/TambahInventaris")
);
const DetailInventaris = lazy(() =>
  import("~/pages/inventaris/DetailInventaris")
);
const UbahInventaris = lazy(() => import("~/pages/inventaris/UbahInventaris"));

// sig

const DaftarPeta = lazy(() => import("~/pages/peta/crud/list"));
const TambahPeta = lazy(() => import("~/pages/peta/crud/add-peta"));
const ChangeStatusSig = lazy(() => import("~/pages/peta/crud/change-status"));
const ChangeClasification = lazy(() =>
  import("~/pages/peta/crud/change-clasification")
);

// auth
const Logout = lazy(() => import("~/pages/auth/Logout"));

// laporan

const LaporanKematian = lazy(() => import("~/pages/laporan/Kematian"));
const LaporanKelahiran = lazy(() => import("~/pages/laporan/Kelahiran"));
const LaporanMonografi = lazy(() => import("~/pages/laporan/Monografi"));
const LaporanPresensi = lazy(() => import("~/pages/laporan/Presensi"));

// survei

const DaftarSurvei = lazy(() => import("~/pages/survei/Daftar"));
const TambahSurvei = lazy(() => import("~/pages/survei/Tambah"));
const UbahSurvei = lazy(() => import("~/pages/survei/Ubah"));
const DemografiSurvei = lazy(() => import("~/pages/survei/Demografi"));

// PPID
const DaftarSopPelayananInformasi = lazy(() =>
  import("~/pages/ppid/sop-pelayanan/daftar")
);
const TambahSopPelayananInformasi = lazy(() =>
  import("~/pages/ppid/sop-pelayanan/tambah")
);
const UbahSopPelayananInformasi = lazy(() =>
  import("~/pages/ppid/sop-pelayanan/ubah")
);

// DATADESA

// PERENCANAAN
const DaftarPerencanaan = lazy(() =>
  import("~/pages/datadesa/perencanaan/daftar-perencanaan")
);
const FormPerencanaan = lazy(() =>
  import("~/pages/datadesa/perencanaan/form-perencanaan")
);

// PRODUK HUKUM
const PeraturanDiDesa = lazy(() =>
  import("~/pages/datadesa/produk-hukum/daftar-peraturan-desa")
);
const FormPeraturanDesa = lazy(() =>
  import("~/pages/datadesa/produk-hukum/form-peraturan-desa")
);

//PROFILE PPID
const ProfilePPID = lazy(() => import("~/pages/ppid/profile-ppid/profile"));
const VisiMisiPPID = lazy(() => import("~/pages/ppid/profile-ppid/visi-misi"));
const TugasDanFungsi = lazy(() =>
  import("~/pages/ppid/profile-ppid/tugas-fungsi")
);
const MaklumatPelayanan = lazy(() =>
  import("~/pages/ppid/profile-ppid/maklumat-pelayanan")
);
const FormDIP = lazy(() => import("~/pages/ppid/dip/form-dip"));
const DaftarDIP = lazy(() => import("~/pages/ppid/dip/daftar-dip"));
const DaftarDIK = lazy(() => import("~/pages/ppid/dik/daftar-dik"));
const FormDIK = lazy(() => import("~/pages/ppid/dik/form-dik"));
const PermohonanInformasi = lazy(() =>
  import("~/pages/ppid/layanan-informasi/daftar-permohonan-informasi")
);
const PengajuanKeberatan = lazy(() =>
  import("~/pages/ppid/layanan-informasi/daftar-pengajuan-keberatan")
);

const DetailLayananInformasi = lazy(() =>
  import("~/pages/ppid/layanan-informasi/detail-layanan-informasi")
);

const DaftarJenisInformasi = lazy(() =>
  import("~/pages/ppid/jenis-informasi/daftar-jenis-informasi")
);
const UpdateJenisInformasi = lazy(() =>
  import("~/pages/ppid/jenis-informasi/update")
);
const TambahInformasiBerkala = lazy(() =>
  import("~/pages/ppid/jenis-informasi/tambah")
);

const TentangKamiPPID = lazy(() =>
  import("~/pages/ppid/profile-ppid/tentang-kami")
);

// const Notifikasi = lazy(() => import("~/pages/notifikasi/Daftar"));

const dashboard = {
  path: "/user/dashboard",
  name: "Dashboard",
  icon: "uil-home-alt",
  exact: true,
  component: Dashboard,
  route: PrivateRoute,
  header: "Kependudukan",
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KEPALADESA,
    ROLES.SEKRETARIS,
    ROLES.KASIPEMERINTAHAN,
    ROLES.KASILAYANAN,
    ROLES.KAURKEUANGAN,
    ROLES.KAURUMUM,
    ROLES.KAURPERENCANAAN,
    ROLES.KADUS,
  ],
};

// const notifikasi = {
//   path: "/user/notifikasi",
//   exact: true,
//   component: Notifikasi,
//   route: PrivateRoute,
//   roles: [
//     ROLES.ADMIN_DESA,
//     ROLES.KEPALADESA,
//     ROLES.SEKRETARIS,
//     ROLES.KASIPEMERINTAHAN,
//     ROLES.KASILAYANAN,
//     ROLES.KAURKEUANGAN,
//     ROLES.KAURUMUM,
//     ROLES.KAURPERENCANAAN,
//     ROLES.KADUS,
//   ],
// };

const keluarga = {
  path: "/user/keluarga",
  name: "Keluarga",
  icon: "uil-users-alt",
  exact: true,
  route: PrivateRoute,
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KEPALADESA,
    ROLES.SEKRETARIS,
    ROLES.KASIPEMERINTAHAN,
    ROLES.KASILAYANAN,
    ROLES.KADUS,
  ],
  children: [
    {
      path: "/user/keluarga/daftar-keluarga",
      name: "Daftar Keluarga",
      component: DaftarKeluarga,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/keluarga/tambah-keluarga/",
      name: "Tambah Keluarga",
      component: TambahFormKeluarga,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
    },
    {
      path: "/user/keluarga/detail/:id",
      component: DetailFormKeluarga,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/keluarga/ubah/:id",
      component: UbahFormKeluarga,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
    },
  ],
};

const penduduk = {
  path: "/user/penduduk",
  name: "Penduduk",
  icon: "uil-user",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KEPALADESA,
    ROLES.SEKRETARIS,
    ROLES.KASIPEMERINTAHAN,
    ROLES.KASILAYANAN,
    ROLES.KADUS,
  ],
  children: [
    {
      path: "/user/penduduk/daftar-penduduk",
      name: "Daftar Penduduk",
      component: DaftarPenduduk,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/penduduk/tambah-penduduk",
      name: "Tambah Penduduk",
      component: FormPenduduk,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
    },
    {
      path: "/user/penduduk/detail/:id",
      component: DetailPenduduk,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/penduduk/ubah/:id",
      component: EditPenduduk,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
    },
  ],
};

const peristiwa = {
  path: "/user/peristiwa",
  name: "Peristiwa",
  icon: "uil-clipboard-notes",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KASIPEMERINTAHAN,
    ROLES.KASILAYANAN,
    ROLES.KADUS,
  ],
  children: [
    {
      path: "/user/peristiwa/kelahiran",
      name: "Kelahiran",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
      children: [
        {
          path: "/user/peristiwa/kelahiran/daftar-kelahiran",
          name: "Daftar Kelahiran",
          component: DaftarKelahiran,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/kelahiran/tambah-kelahiran",
          name: "Tambah Kelahiran",
          component: TambahKelahiran,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/kelahiran/detail/:id",
          component: DetailKelahiran,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/kelahiran/ubah/:id",
          component: UbahKelahiran,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/kelahiran/pindah-kelahiran-ke-penduduk/:id",
          component: PindahKelahiranPenduduk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/peristiwa/kematian",
      name: "Kematian",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
      children: [
        {
          path: "/user/peristiwa/kematian/daftar-kematian",
          name: "Daftar Kematian",
          component: DaftarKematian,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/kematian/tambah-kematian",
          name: "Tambah Kematian",
          component: TambahKematian,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/kematian/detail/:id",
          component: DetailKematian,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/peristiwa/lahir-mati",
      name: "Lahir Mati",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
      children: [
        {
          path: "/user/peristiwa/lahir-mati/daftar-lahir-mati",
          name: "Daftar Lahir Mati",
          component: DaftarLahirMati,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/lahir-mati/tambah-lahir-mati",
          name: "Tambah Lahir Mati",
          component: TambahLahirMati,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/lahir-mati/detail/:id",
          component: DetailLahirMati,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/lahir-mati/ubah/:id",
          component: UbahLahirMati,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/peristiwa/pecah-kk",
      name: "Pecah KK",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
      children: [
        {
          path: "/user/peristiwa/pecah-kk/daftar-pecah-kk",
          name: "Daftar Pecah KK",
          component: DaftarPecahKK,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/pecah-kk/tambah-pecah-kk",
          name: "Tambah Pecah KK",
          component: TambahPecahKK,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/pecah-kk/detail/:id",
          component: DetailPecahKK,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASILAYANAN, ROLES.KADUS],
        },
      ],
    },

    {
      path: "/user/peristiwa/pindah-keluar",
      name: "Pindah Keluar",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
      children: [
        {
          path: "/user/peristiwa/pindah-keluar/daftar-pindah-keluar",
          name: "Daftar Pindah Keluar",
          component: DaftarPindahKeluar,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/pindah-keluar/tambah-pindah-keluar",
          name: "Tambah Pindah Keluar",
          component: TambahPindahKeluar,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/pindah-keluar/detail/:id",
          component: DetailPindahKeluar,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/peristiwa/datang-masuk",
      name: "Datang Masuk",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
      children: [
        {
          path: "/user/peristiwa/datang-masuk/daftar-datang-masuk",
          name: "Daftar Datang Masuk",
          component: DaftarPindahMasuk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/datang-masuk/tambah-datang-masuk",
          name: "Tambah Datang Masuk",
          component: TambahPindahMasuk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
        },
        {
          path: "/user/peristiwa/datang-masuk/detail/:id",
          component: DetailDatangMasuk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KASIPEMERINTAHAN, ROLES.KADUS],
        },
      ],
    },
  ],
};

const kategorilayanan = {
  path: "/user/layanan/",
  name: "Layanan",
  icon: "uil-file-edit-alt",
  exact: true,
  route: PrivateRoute,
  roles: [ROLES.ADMIN_DESA],
  component: ListsConfigLayanan,
  children: [
    {
      path: "/user/layanan/kategori-layanan/",
      name: "Kategori Layanan",
      exact: true,
      component: KategoriLayanan,
      route: PrivateRoute,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/layanan/daftar-layanan-administrasi/",
      exact: true,
      component: DaftarLayananAdministrasi,
      route: PrivateRoute,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/layanan/daftar-layanan-administrasi/:slug/persyaratan",
      exact: true,
      component: PersyaratanAdministrasi,
      route: PrivateRoute,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/layanan/daftar-layanan-administrasi/:slug/tambah",
      exact: true,
      component: GenerateSurat,
      route: PrivateRoute,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/layanan/daftar-layanan-administrasi/:slug/print/:id",
      exact: true,
      component: FormCetak,
      route: PrivateRoute,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/layanan/daftar-layanan-administrasi/:slug",
      exact: true,
      component: DynamicListAdministrasi,
      route: PrivateRoute,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/layanan/dinamis-layanan/",
      exact: true,
      route: PrivateRoute,
      roles: [ROLES.ADMIN_DESA],
    },
  ],
};

const listsuratlayanan = {
  path: "/user/layanan/:slug",
  exact: true,
  route: PrivateRoute,
  roles: [ROLES.ADMIN_DESA],
  component: ListsSuratLayanan,
};

const createsuratlayanan = {
  path: "/user/layanan/:slug/tambah-surat",
  exact: true,
  route: PrivateRoute,
  roles: [ROLES.ADMIN_DESA],
  component: CreateSuratLayanan,
};

const printsuratlayanan = {
  path: "/user/layanan/:slug/print/:id",
  exact: true,
  route: PrivateRoute,
  roles: [ROLES.ADMIN_DESA],
  component: PrintSuratLayanan,
};

const sarpras = {
  path: "/user/sarana-prasarana",
  name: "Sarana Prasarana",
  icon: "uil-store",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
  children: [
    {
      path: "/user/sarana-prasarana/daftar-sarana-prasarana",
      name: "Daftar Sarpras",
      component: DaftarSaranaPrasarana,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
    {
      path: "/user/sarana-prasarana/tambah-sarana-prasarana",
      name: "Tambah Sarpras",
      component: TambahSaranaPrasarana,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
    {
      path: "/user/sarana-prasarana/detail-sarana-prasarana/:id",
      component: DetailSaranaPrasarana,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
    {
      path: "/user/sarana-prasarana/ubah-sarana-prasarana/:id",
      component: UbahSaranaPrasarana,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
  ],
};

const persuratan = {
  path: "/user/persuratan",
  name: "Persuratan",
  icon: "uil-copy",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
  children: [
    {
      path: "/user/persuratan/surat-masuk",
      name: "Surat Masuk",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
      children: [
        {
          path: "/user/persuratan/surat-masuk/daftar-surat-masuk/",
          name: "Daftar Surat Masuk",
          component: DaftarSuratMasuk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
        {
          path: "/user/persuratan/surat-masuk/tambah-surat-masuk/",
          name: "Tambah Surat Masuk",
          component: TambahSuratMasuk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
        {
          path: "/user/persuratan/surat-masuk/detail/:id",
          component: DetailSuratMasuk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
        {
          path: "/user/persuratan/surat-masuk/ubah/:id",
          component: UbahSuratMasuk,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/persuratan/surat-keluar",
      name: "Surat Keluar",
      route: PrivateRoute,
      show: true,
      exact: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KAURUMUM,
        ROLES.KADUS,
      ],
      children: [
        {
          path: "/user/persuratan/surat-keluar/daftar-surat-keluar/",
          name: "Daftar Surat Keluar",
          component: DaftarSuratKeluar,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
        {
          path: "/user/persuratan/surat-keluar/tambah-surat-keluar/",
          name: "Tambah Surat Keluar",
          component: TambahSuratKeluar,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
        {
          path: "/user/persuratan/surat-keluar/detail/:id",
          component: DetailSuratKeluar,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
        {
          path: "/user/persuratan/surat-keluar/ubah/:id",
          component: UbahSuratKeluar,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM, ROLES.KADUS],
        },
      ],
    },
  ],
};

const inventaris = {
  path: "/user/inventaris",
  name: "Inventaris",
  icon: "uil-store-alt",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
  children: [
    {
      path: "/user/inventaris/daftar-inventaris",
      name: "Daftar Inventaris",
      component: DaftarInventaris,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
    {
      path: "/user/inventaris/tambah-inventaris/",
      name: "Tambah Inventaris",
      component: TambahInventaris,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
    {
      path: "/user/inventaris/detail/:id",
      component: DetailInventaris,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
    {
      path: "/user/inventaris/ubah/:id",
      component: UbahInventaris,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KAURUMUM],
    },
  ],
};

const perangkat = {
  path: "/user/perangkat",
  name: "Perangkat",
  icon: "uil-user-square",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [ROLES.ADMIN_DESA],
  children: [
    {
      path: "/user/perangkat/data-perangkat",
      name: "Data Perangkat",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA],
      children: [
        {
          path: "/user/perangkat/data-perangkat/daftar-perangkat",
          name: "Daftar Perangkat",
          component: DaftarPerangkat,
          roles: [ROLES.ADMIN_DESA],
          route: PrivateRoute,
          show: true,
        },
        {
          path: "/user/perangkat/data-perangkat/tambah-perangkat",
          name: "Tambah Perangkat",
          component: TambahFormPerangkat,
          roles: [ROLES.ADMIN_DESA],
          route: PrivateRoute,
          show: true,
        },
        {
          path: "/user/perangkat/tambah-ke-pengguna/:id",
          component: TambahKePengguna,
          roles: [ROLES.ADMIN_DESA],
          route: PrivateRoute,
          show: true,
        },
      ],
    },
    {
      path: "/user/perangkat/jabatan/daftar-jabatan",
      name: "Jabatan",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA],
      children: [
        {
          path: "/user/perangkat/jabatan/daftar-jabatan",
          name: "Daftar Jabatan",
          component: DaftarJabatan,
          roles: [ROLES.ADMIN_DESA],
          route: PrivateRoute,
          show: true,
        },
        {
          path: "/user/perangkat/jabatan/tambah-jabatan",
          name: "Tambah Jabatan",
          component: TambahJabatan,
          roles: [ROLES.ADMIN_DESA],
          route: PrivateRoute,
          show: true,
        },
        {
          path: "/user/perangkat/jabatan/ubah-jabatan/:id",
          component: EditJabatan,
          roles: [ROLES.ADMIN_DESA],
          route: PrivateRoute,
          show: true,
        },
      ],
    },
    {
      path: "/user/perangkat/daftar-presensi",
      name: "Daftar Presensi",
      component: DaftarPresensi,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
      show: true,
    },
    {
      path: "/user/perangkat/tambah-presensi/",
      name: "Form Presensi",
      component: TambahPresensi,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
      show: true,
    },
    {
      path: "/user/perangkat/ubah/:id",
      component: EditPerangkat,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
      show: true,
    },
    {
      path: "/user/perangkat/detail/:id",
      component: DetailPerangkat,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
      show: true,
    },
  ],
};

//website
const websitedesa = {
  path: "/user/website",
  name: "Website",
  icon: "uil-globe",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
  children: [
    {
      path: "/user/website/berita",
      name: "Berita",
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
      children: [
        {
          path: "/user/website/berita/daftar-berita",
          name: "Daftar Berita",
          component: DaftarBerita,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/berita/tambah-berita/",
          name: "Tambah Berita",
          component: TambahBerita,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/berita/daftar-kategori-berita",
          name: "Daftar Kategori",
          component: DaftarKategoriBerita,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/berita/tambah-kategori-berita/",
          name: "Tambah Kategori",
          component: TambahKategoriBerita,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/berita/ubah/:id",
          component: EditBerita,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/kategori-berita/ubah/:id",
          component: EditKategoriBerita,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/website/potensi",
      name: "Potensi",
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
      children: [
        {
          path: "/user/website/potensi/daftar-potensi",
          name: "Daftar Potensi",
          component: DaftarPotensi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/potensi/tambah-potensi/",
          name: "Tambah Potensi",
          component: TambahPotensi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        // {
        //   path: "/user/potensi/daftar-kategori-potensi",
        //   name: "Daftar Kategori",
        //   component: DaftarKategoriPotensi,
        //   route: PrivateRoute,
        //   show: true,
        //   roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        // },
        // {
        //   path: "/user/potensi/tambah-kategori-potensi/",
        //   name: "Tambah Kategori",
        //   component: TambahKategoriPotensi,
        //   route: PrivateRoute,
        //   show: true,
        //   roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        // },
        {
          path: "/user/website/potensi/ubah/:id",
          component: EditPotensi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        // {
        //   path: "/user/kategori-potensi/ubah/:id",
        //   component: EditKategoriPotensi,
        //   route: PrivateRoute,
        //   show: true,
        //   roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        // },
      ],
    },
    {
      path: "/user/website/informasi",
      name: "Informasi",
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
      children: [
        {
          path: "/user/website/informasi/daftar-informasi",
          name: "Daftar Informasi",
          component: DaftarInformasi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/informasi/tambah-informasi/",
          name: "Tambah Informasi",
          component: TambahInformasi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/informasi/daftar-kategori-informasi",
          name: "Daftar Kategori",
          component: DaftarKategoriInformasi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/informasi/tambah-kategori-informasi/",
          name: "Tambah Kategori",
          component: TambahKategoriInformasi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/informasi/ubah/:id",
          component: EditInformasi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/informasi/kategori-informasi/ubah/:id",
          component: EditKategoriInformasi,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/website/hero",
      name: "Hero",
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
      children: [
        {
          path: "/user/website/hero/tambah-hero",
          component: TambahHero,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/hero/daftar-hero",
          name: "Hero",
          component: DaftarHero,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/hero/pengaturan-hero",
          name: "Pengaturan Hero",
          component: HeroSetting,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
        {
          path: "/user/website/hero/ubah/:id",
          component: EditHero,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
        },
      ],
    },
  ],
};

const laporwarga = {
  path: "/user/lapor/lapor-warga/",
  name: "Laporan Warga",
  icon: "uil-clipboard-notes",
  component: LaporWarga,
  route: PrivateRoute,
  show: true,
  roles: [ROLES.ADMIN_DESA, ROLES.KEPALADESA, ROLES.SEKRETARIS, ROLES.KADUS],
};

const peta = {
  path: "/user/peta",
  name: "Peta",
  icon: "uil-map",
  exact: true,
  roles: [ROLES.ADMIN_DESA, ROLES.SEKRETARIS, ROLES.KADUS],
  route: PrivateRoute,
  children: [
    {
      path: "/user/peta/daftar-peta",
      name: "Daftar Peta",
      exact: true,
      roles: [ROLES.ADMIN_DESA, ROLES.SEKRETARIS, ROLES.KADUS],
      component: DaftarPeta,
      route: PrivateRoute,
    },
    {
      path: "/user/peta/tambah-peta",
      name: "Tambah Peta",
      exact: true,
      roles: [ROLES.ADMIN_DESA, ROLES.SEKRETARIS, ROLES.KADUS],
      component: TambahPeta,
      route: PrivateRoute,
    },
    {
      path: "/user/peta/ubah-status/:id",
      exact: true,
      roles: [ROLES.ADMIN_DESA, ROLES.SEKRETARIS, ROLES.KADUS],
      component: ChangeStatusSig,
      route: PrivateRoute,
    },
    {
      path: "/user/peta/ubah-klasifikasi/:sigTipeID",
      exact: true,
      roles: [ROLES.ADMIN_DESA, ROLES.SEKRETARIS, ROLES.KADUS],
      component: ChangeClasification,
      route: PrivateRoute,
    },
  ],
};

//profil

const profildesa = {
  path: "/user/profil",
  name: "Profil",
  icon: "uil-user",
  exact: true,
  route: PrivateRoute,
  show: true,
  roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
  children: [
    {
      path: "/user/profil/profil-desa/",
      name: "Profil Desa",
      component: ProfilDesa,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
    },
    {
      path: "/user/profil/visi-dan-misi/",
      name: "Visi Dan Misi",
      component: VisiDanMisi,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
    },
    {
      path: "/user/profil/sejarah/",
      name: "Sejarah",
      component: Sejarah,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
    },
    {
      path: "/user/profil/batas-desa/",
      name: "Batas Desa",
      component: UpdateBatasDesa,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
    },
  ],
};

const hierarkidesa = {
  path: "/user/hierarki-desa",
  name: "Hierarki Desa",
  icon: "uil-sitemap",
  exact: true,
  route: PrivateRoute,
  roles: [ROLES.ADMIN_DESA],
  children: [
    {
      path: "/user/hierarki-desa/daftar-subdesa",
      isRead: true,
      type: "subdesa",
      exact: true,
      component: DaftarSubDesa,
      show: false,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/daftar-subsubdesa",
      isRead: true,
      type: "subsubdesa",
      exact: true,
      component: DaftarSubSubDesa,
      show: false,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/daftar-rw",
      name: "RW",
      type: "rw",
      exact: true,
      component: DaftarRW,
      show: false,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/daftar-rt",
      name: "RT",
      type: "rt",
      exact: true,
      component: DaftarRT,
      show: false,
      roles: [ROLES.ADMIN_DESA],
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/tambah-subdesa",
      exact: true,
      type: "subdesa",
      component: TambahSubDesa,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/tambah-subsubdesa",
      exact: true,
      type: "subsubdesa",
      component: TambahSubSubDesa,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/tambah-rw",
      exact: true,
      type: "rw",
      component: TambahRW,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/tambah-rt",
      exact: true,
      type: "rt",
      component: TambahRT,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/ubah-subdesa/:id",
      exact: true,
      type: "subdesa",
      component: UbahSubDesa,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/ubah-subsubdesa/:id",
      exact: true,
      type: "subsubdesa",
      component: UbahSubSubDesa,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/ubah-rw/:id",
      exact: true,
      type: "rw",
      component: UbahRW,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
    {
      path: "/user/hierarki-desa/ubah-rt/:id",
      exact: true,
      type: "rt",
      component: UbahRT,
      roles: [ROLES.ADMIN_DESA],
      show: false,
      route: PrivateRoute,
    },
  ],
};

//pengguna
const pengguna = {
  path: "/user/pengguna",
  name: "Pengguna",
  icon: "uil-user-circle",
  route: PrivateRoute,
  roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
  children: [
    {
      path: "/user/pengguna/daftar-pengguna/",
      name: "Daftar Pengguna",
      component: DaftarPengguna,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
    },
    {
      path: "/user/pengguna/ubah/:id",
      component: EditPengguna,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
    },
    {
      path: "/user/pengguna/ubah-password/:id",
      component: EditPasswordPengguna,
      route: PrivateRoute,
      show: true,
      roles: [ROLES.ADMIN_DESA, ROLES.KADUS],
    },
  ],
};

// root routes
const rootRoute = {
  path: "/",
  exact: true,
  component: LoginHyperHtml,
  route: Route,
};

// keuangan
const keuangan = {
  path: "/user/keuangan",
  name: "Keuangan",
  icon: "mdi mdi-finance",
  exact: true,
  show: true,
  route: PrivateRoute,
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KEPALADESA,
    ROLES.SEKRETARIS,
    ROLES.KAURKEUANGAN,
    ROLES.KAURPERENCANAAN,
    ROLES.KADUS,
  ],
  children: [
    {
      path: "/user/keuangan/pendapatan-desa",
      name: "Pendapatan Desa",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARI,
        ROLES.KAURKEUANGAN,
        ROLES.KADUS,
      ],
      children: [
        {
          path: "/user/keuangan/pendapatan-desa/daftar-pendapatan",
          name: "Daftar Pendapatan",
          component: DaftarAnggaran,
          route: PrivateRoute,
          show: true,
          roles: [
            ROLES.ADMIN_DESA,
            ROLES.KEPALADESA,
            ROLES.SEKRETARIS,
            ROLES.KAURKEUANGAN,
            ROLES.KADUS,
          ],
        },

        {
          path: "/user/keuangan/pendapatan-desa/daftar-kategori-pendapatan",
          name: "Daftar Kategori",
          component: DaftarKategoriAnggaran,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURKEUANGAN, ROLES.KADUS],
        },
        {
          path: "/user/keuangan/pendapatan-desa/tambah-pendapatan",
          name: "Tambah Pendapatan",
          component: TambahAnggaranPendapatan,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURKEUANGAN, ROLES.KADUS],
        },
        {
          path: "/user/keuangan/pendapatan-desa/tambah-kategori-pendapatan",
          name: "Tambah Kategori",
          component: TambahKategoriPendapatan,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURKEUANGAN, ROLES.KADUS],
        },
        {
          path: "/user/keuangan/pendapatan-desa/kategori-pendapatan/ubah/:id",
          component: EditKategoriAnggaran,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURKEUANGAN, ROLES.KADUS],
        },
        {
          path: "/user/keuangan/pendapatan-desa/ubah/:id",
          component: EditAnggaran,
          route: PrivateRoute,
          show: true,
          roles: [ROLES.ADMIN_DESA, ROLES.KAURKEUANGAN, ROLES.KADUS],
        },
      ],
    },
    {
      path: "/user/keuangan/anggaran-belanja",
      name: "Anggaran Belanja",
      exact: true,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARI,
        ROLES.KAURKEUANGAN,
        ROLES.KAURPERENCANAAN,
        ROLES.KADUS,
      ],
      children: [
        {
          path: "/user/keuangan/anggaran-belanja/daftar-belanja-desa",
          name: "Daftar Belanja",
          component: DaftarBelanja,
          route: PrivateRoute,
          show: true,
          roles: [
            ROLES.ADMIN_DESA,
            ROLES.KEPALADESA,
            ROLES.SEKRETARIS,
            ROLES.KAURKEUANGAN,
            ROLES.KAURPERENCANAAN,
            ROLES.KADUS,
          ],
        },
        {
          path: "/user/keuangan/anggaran-belanja/daftar-kategori-belanja",
          name: "Daftar Kategori",
          component: DaftarKategoriBelanja,
          route: PrivateRoute,
          show: true,
          roles: [
            ROLES.ADMIN_DESA,
            ROLES.KAURKEUANGAN,
            ROLES.KAURPERENCANAAN,
            ROLES.KADUS,
          ],
        },
        {
          path: "/user/keuangan/anggaran-belanja/tambah-belanja-desa",
          name: "Tambah Belanja",
          component: TambahBelanja,
          route: PrivateRoute,
          show: true,
          roles: [
            ROLES.ADMIN_DESA,
            ROLES.KAURKEUANGAN,
            ROLES.KAURPERENCANAAN,
            ROLES.KADUS,
          ],
        },
        {
          path: "/user/keuangan/anggaran-belanja/tambah-kategori-belanja",
          name: "Tambah Kategori",
          component: TambahKategoriBelanja,
          route: PrivateRoute,
          show: true,
          roles: [
            ROLES.ADMIN_DESA,
            ROLES.KAURKEUANGAN,
            ROLES.KAURPERENCANAAN,
            ROLES.KADUS,
          ],
        },
        {
          path: "/user/keuangan/anggaran-belanja/kategori-belanja/ubah/:id",
          component: EditKategoriBelanja,
          route: PrivateRoute,
          show: true,
          roles: [
            ROLES.ADMIN_DESA,
            ROLES.KAURKEUANGAN,
            ROLES.KAURPERENCANAAN,
            ROLES.KADUS,
          ],
        },
        {
          path: "/user/keuangan/anggaran-belanja/ubah/:id",
          component: EditBelanja,
          route: PrivateRoute,
          show: true,
          roles: [
            ROLES.ADMIN_DESA,
            ROLES.KAURKEUANGAN,
            ROLES.KAURPERENCANAAN,
            ROLES.KADUS,
          ],
        },
      ],
    },
  ],
};

// survei

const survei = {
  path: "/user/survei",
  name: "Survei",
  icon: "uil-list-ul",
  exact: true,
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KEPALADESA,
    ROLES.SEKRETARIS,
    ROLES.KASIPEMERINTAHAN,
    ROLES.KASILAYANAN,
    ROLES.KADUS,
  ],
  children: [
    {
      path: "/user/survei/daftar-survei",
      name: "Daftar Survei",
      component: DaftarSurvei,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/survei/tambah-survei",
      name: "Tambah Survei",
      component: TambahSurvei,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/survei/ubah/:id",
      component: UbahSurvei,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/survei/demografi/:id",
      component: DemografiSurvei,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
  ],
};

// laporan

const laporan = {
  path: "/user/laporan",
  name: "Laporan",
  route: PrivateRoute,
  exact: true,
  icon: "uil-file",
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KEPALADESA,
    ROLES.SEKRETARIS,
    ROLES.KASIPEMERINTAHAN,
    ROLES.KASILAYANAN,
    ROLES.KADUS,
  ],
  children: [
    {
      path: "/user/laporan/kelahiran",
      name: "Kelahiran/triwulan",
      component: LaporanKelahiran,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/laporan/kematian",
      name: "Kematian/triwulan",
      component: LaporanKematian,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/laporan/monografi",
      name: "Monografi",
      component: LaporanMonografi,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/laporan/presensi",
      name: "Presensi",
      component: LaporanPresensi,
      route: PrivateRoute,
      show: true,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KADUS,
      ],
    },
  ],
};

const notFoundRoute = {
  path: "*",
  show: true,
  component: ErrorPageNotFound,
  route: PrivateRoute,
};

const changepassword = {
  path: "/user/account/edit-password",
  component: EditPassword,
  route: PrivateRoute,
};

// ppid

const ppid = {
  path: "/user/ppid",
  name: "PPID",
  route: PrivateRoute,
  exact: true,
  icon: "uil-file",
  roles: [ROLES.ADMIN_DESA],
  children: [
    {
      path: "/user/ppid/profile-ppid",
      name: "Profil PPID",
      route: PrivateRoute,
      exact: true,
      roles: [ROLES.ADMIN_DESA],
      children: [
        {
          path: "/user/ppid/profile-ppid/profile",
          name: "Profil",
          route: PrivateRoute,
          exact: true,
          component: ProfilePPID,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/profile-ppid/visi-misi",
          name: "Visi dan Misi",
          route: PrivateRoute,
          exact: true,
          component: VisiMisiPPID,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/profile-ppid/tugas-dan-fungsi",
          name: "Tugas dan Fungsi",
          route: PrivateRoute,
          exact: true,
          component: TugasDanFungsi,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/profile-ppid/maklumat-pelayanan",
          name: "Maklumat Pelayanan",
          route: PrivateRoute,
          exact: true,
          component: MaklumatPelayanan,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/profile-ppid/tentang-kami",
          name: "Tentang Kami",
          route: PrivateRoute,
          exact: true,
          roles: [ROLES.ADMIN_DESA],
          component: TentangKamiPPID,
        },
      ],
    },
    {
      path: "/user/ppid/profile-ppid/layanan-informasi",
      name: "Layanan Informasi",
      route: PrivateRoute,
      exact: true,
      roles: [ROLES.ADMIN_DESA],
      children: [
        {
          path: "/user/ppid/profile-ppid/daftar-permohonan-informasi",
          name: "Daftar Permohonan Informasi",
          route: PrivateRoute,
          exact: true,
          component: PermohonanInformasi,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/profile-ppid/daftar-pengajuan-keberatan",
          name: "Daftar Pengajuan Keberatan",
          route: PrivateRoute,
          exact: true,
          component: PengajuanKeberatan,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/profile-ppid/detail-layanan-informasi/:id",
          route: PrivateRoute,
          exact: true,
          component: DetailLayananInformasi,
          roles: [ROLES.ADMIN_DESA],
        },
      ],
    },
    {
      path: "/user/ppid/profile-ppid/daftar-dip",
      name: "DIP",
      route: PrivateRoute,
      exact: true,
      component: DaftarDIP,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/ppid/profile-ppid/form-dip/:id",
      route: PrivateRoute,
      exact: true,
      component: FormDIP,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/ppid/profile-ppid/daftar-dik",
      name: "DIK",
      route: PrivateRoute,
      exact: true,
      component: DaftarDIK,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/ppid/profile-ppid/form-dik/:id",
      route: PrivateRoute,
      exact: true,
      component: FormDIK,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/ppid/profile-ppid/daftar-jenis-informasi",
      name: "Jenis Informasi",
      route: PrivateRoute,
      exact: true,
      component: DaftarJenisInformasi,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/ppid/profile-ppid/tambah-informasi/",
      route: PrivateRoute,
      exact: true,
      component: TambahInformasiBerkala,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/ppid/profile-ppid/update-informasi/:id",
      route: PrivateRoute,
      exact: true,
      component: UpdateJenisInformasi,
      roles: [ROLES.ADMIN_DESA],
    },
    {
      path: "/user/ppid/sop-pelayanan-informasi",
      name: "SOP Pelayanan",
      route: PrivateRoute,
      exact: true,
      roles: [ROLES.ADMIN_DESA],
      children: [
        {
          path: "/user/ppid/sop-pelayanan-informasi/daftar",
          name: "Daftar SOP Pelayanan Informasi",
          route: PrivateRoute,
          exact: true,
          component: DaftarSopPelayananInformasi,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/sop-pelayanan-informasi/tambah",
          name: "Tambah SOP Pelayanan Informasi",
          route: PrivateRoute,
          exact: true,
          component: TambahSopPelayananInformasi,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/ppid/sop-pelayanan-informasi/ubah/:id",
          route: PrivateRoute,
          exact: true,
          component: UbahSopPelayananInformasi,
          roles: [ROLES.ADMIN_DESA],
        },
      ],
    },
  ],
};

const datadesa = {
  path: "/user/datadesa",
  name: "Data Desa",
  route: PrivateRoute,
  exact: true,
  icon: "uil-database",
  roles: [ROLES.ADMIN_DESA],
  children: [
    {
      path: "/user/datadesa/perencanaan",
      name: "Perencanaan",
      route: PrivateRoute,
      exact: true,
      roles: [ROLES.ADMIN_DESA],
      children: [
        {
          path: "/user/datadesa/perencanaan/daftar-perencanaan",
          name: "Daftar Perencanaan",
          route: PrivateRoute,
          exact: true,
          component: DaftarPerencanaan,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          name: "Tambah Perencanaan Desa",
          path: "/user/datadesa/perencanaan/daftar-perencanaan/tambah",
          route: PrivateRoute,
          exact: true,
          component: () => (
            <Redirect to="/user/datadesa/perencanaan/form-perencanaan/0/?form=create" />
          ),
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/datadesa/perencanaan/form-perencanaan/:id",
          route: PrivateRoute,
          exact: true,
          component: FormPerencanaan,
          roles: [ROLES.ADMIN_DESA],
        },
      ],
    },
    {
      path: "/user/datadesa/produk-hukum",
      name: "Produk Hukum",
      route: PrivateRoute,
      exact: true,
      roles: [ROLES.ADMIN_DESA],
      children: [
        {
          path: "/user/datadesa/produk-hukum/peraturan-desa",
          name: "Peraturan Desa",
          route: PrivateRoute,
          exact: true,
          component: PeraturanDiDesa,
          roles: [ROLES.ADMIN_DESA],
        },
        {
          name: "Tambah Peraturan Desa",
          path: "/user/datadesa/produk-hukum/form-peraturan-desa/tambah",
          route: PrivateRoute,
          exact: true,
          component: () => (
            <Redirect to="/user/datadesa/produk-hukum/form-peraturan-desa/0/?form=create" />
          ),
          roles: [ROLES.ADMIN_DESA],
        },
        {
          path: "/user/datadesa/produk-hukum/form-peraturan-desa/:id",
          route: PrivateRoute,
          exact: true,
          component: FormPeraturanDesa,
          roles: [ROLES.ADMIN_DESA],
        },
      ],
    },
  ],
};

const cctv = {
  path: "/user/cctv/",
  name: "CCTV",
  icon: "mdi mdi-cctv",
  exact: true,
  route: PrivateRoute,
  roles: [
    ROLES.ADMIN_DESA,
    ROLES.KEPALADESA,
    ROLES.SEKRETARIS,
    ROLES.KASIPEMERINTAHAN,
    ROLES.KASILAYANAN,
    ROLES.KADUS,
  ],
  children: [
    {
      path: "/user/cctv/daftar-cctv/",
      name: "Daftar CCTV",
      component: DaftarCCTVTable,
      route: PrivateRoute,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/cctv/tambah-cctv/",
      name: "Tambah CCTV",
      component: TambahCCTV,
      route: PrivateRoute,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/cctv/view-cctv/",
      name: "View CCTV",
      component: DaftarCCTV,
      route: PrivateRoute,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/cctv/persebaran-cctv/",
      name: "Peta Persebaran CCTV",
      component: PersebaranPetaCCTV,
      route: PrivateRoute,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
    {
      path: "/user/cctv/ubah/:id",
      component: UbahCCTV,
      route: PrivateRoute,
      roles: [
        ROLES.ADMIN_DESA,
        ROLES.KEPALADESA,
        ROLES.SEKRETARIS,
        ROLES.KASIPEMERINTAHAN,
        ROLES.KASILAYANAN,
        ROLES.KADUS,
      ],
    },
  ],
};

// public

// auth
const authRoutes = {
  path: "/user/account",
  name: "Auth",
  children: [
    {
      path: "/user/account/login",
      name: "Login",
      show: true,
      component: LoginHyperHtml,
      route: Route,
    },
    {
      path: "/user/account/logout",
      name: "Logout",
      show: true,
      component: Logout,
      route: Route,
    },
  ],
};

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
  let flatRoutes = [];

  routes = routes || [];
  routes.forEach((item) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const allRoutes = [
  dashboard,
  keluarga,
  penduduk,
  peristiwa,
  kategorilayanan,
  listsuratlayanan,
  createsuratlayanan,
  printsuratlayanan,
  persuratan,
  sarpras,
  inventaris,
  websitedesa,
  cctv,
  ppid,
  datadesa,
  survei,
  laporwarga,
  peta,
  profildesa,
  hierarkidesa,
  perangkat,
  pengguna,
  rootRoute,
  authRoutes,
  laporan,
  keuangan,
  changepassword,
  notFoundRoute,
];

const authProtectedRoutes = [
  dashboard,
  keluarga,
  penduduk,
  peristiwa,
  kategorilayanan,
  persuratan,
  sarpras,
  inventaris,
  websitedesa,
  cctv,
  ppid,
  datadesa,
  survei,
  laporwarga,
  peta,
  profildesa,
  hierarkidesa,
  perangkat,
  pengguna,
  keuangan,
  laporan,
];

const allFlattenRoutes = flattenRoutes(allRoutes);

export { allRoutes, authProtectedRoutes, allFlattenRoutes };
